@if (isModalClosable || (activeVehicle$ | async)) {
    <div class="modal-header-cit2" tabindex="-1">
        <!-- CLOSE BUTTON -->
        <div class="dismiss"
            (click)="modalRef.hide()"
            [trackLink]="'vehiclePicker:cancel'"
            [trackDelay]="'true'"
            [trackType]="'o'"
            [evar33]="'vehicle switcher:link:cancel'"
            [prop10]="'vehicle switcher:link:cancel'"
            [prop15]="'cancel'">
            <button href="#" class="gb-icon-button" aria-hidden="true"
                attr.aria-label="{{'aoda_close_modal_label' | translate}}">
                <span aria-hidden="true" class="icon-ui-close"></span>
            </button>
        </div>
    </div>
}
<!-- MODAL BODY -->
<div class="modal-body-cit2">
    <!-- SWITCH VEHICLE HEADLINE -->
    <div class="gb-headline3 mb-6">
        {{'vehiclePicker_switchVehicleLabel' | translate }}
    </div>
    <!-- LIST OF VEHICLES -->
    <ul class="modal-vpicker-controls-cit2">
        <li *ngFor="let vehicle of garage | slice:0:5;">
            <!-- VEHICLE LINK -->
            <button href="#" class="img-title d-flex align-items-center dismiss" data-dismiss="modal"
                (click)="setActiveVehicleInGarage(vehicle); modalRef.hide()"
                [trackLink]="'vehiclePicker:vehicle'"
                [trackDelay]="'true'"
                [trackType]="'o'"
                [evar33]="'vehicle switcher:vehicle tile:'+ vehicle.year + ' ' + vehicle.make + ' ' + vehicle.model"
                [prop10]="'vehicle switcher:vehicle tile:'+ vehicle.year + ' ' + vehicle.make + ' ' + vehicle.model"
                [prop15]="vehicle.year + vehicle.make + vehicle.model">


                <!-- VEHICLE IMAGE -->
                <div *ngIf="!hasLocaleNames">
                    <ox-ghost-image [srcUrl]="vehicle.renderImageUrl" altText="{{vehicle.year}} {{vehicle.make}} {{vehicle.model}}"></ox-ghost-image>
                </div>
                <div *ngIf="hasLocaleNames">
                    <ox-ghost-image [srcUrl]="vehicle.renderImageUrl" altText="{{vehicle.year}} {{vehicle.localeMakeName}} {{vehicle.localeModelName}}"></ox-ghost-image>
                </div>
                <!-- VEHICLE YMM -->

                <div *ngIf="!hasLocaleNames">
                    <div class="gb-descriptive1 gb-color-grey-mid-dark">
                        <p class="mb-0" id="vehicle_picker_vehicle_image_{{vehicle.vehicle_id}}">{{vehicle.year}} {{vehicle.make}} {{vehicle.model}}</p>
                    </div>
                </div>
                <div *ngIf="hasLocaleNames">
                    <div class="gb-descriptive1 gb-color-grey-mid-dark">
                        <p class="mb-0" id="vehicle_picker_vehicle_image_{{vehicle.vehicle_id}}">{{vehicle.year}} {{vehicle.localeMakeName}} {{vehicle.localeModelName}}</p>
                    </div>
                </div>
                
            </button>

            <!-- ICON DENOTING CURRENT VEHICLE -->
            <div *ngIf="activeVehicle$ | async as activeVehicle">
                <div *ngIf="vehicle.vehicle_id === activeVehicle.vehicle_id" class="status-icon">
                    <div class="gb-descriptive1 gb-color-grey-mid-dark">
                        <span aria-hidden="true" class="icon-ui-check"></span>
                    </div>
                </div>
            </div>
        </li>
    </ul>
</div>
<!-- MANAGE GARAGE BUTTON -->
<div class="modal-footer-cit2 v-picker">
    <div class="row d-flex">
        <div class="col-12 col-lg-4 cta">
            <a [attr.href]="targetHref" class="gb-secondary-button"
                [evar33]="'vehicle switcher:link:manage garage'"
                [prop10]="'vehicle switcher:link:manage garage'"
                [prop15]="'manage garage'"
                [trackDelay]="'true'" [trackType]="'o'"
                [trackLink]="'vehiclePicker:manageGarage'">
                <span [translate]="'vehiclePicker_manageGarage'"></span>
            </a>
        </div>
    </div>
</div>
